import axios from "axios";

export const GetTopConterList = async (params) => {
    let data =  {
        StartDate : params.startDate,
        EndDate : params.endDate,
        Operator : params.operator,
        ProductType : params.productType,
        CompanyId: params.companyId,
        UserId: params.userId,
        RoleId: params.roleId,
    }
    let Topresponse;
    try{
        Topresponse = await axios.post(`/api/Counter/GetTopCounterList`,data);
        if(Topresponse && Topresponse.status === 200){
            return Topresponse.data.records;
        }else{
            return Topresponse.status;
        }

    }catch(error){
        if(error.Topresponse.status === 401){
            return error.Topresponse.status;
        }
    }
}

export const GetLowestConterList = async (params) => {
    let data =  {
        StartDate : params.startDate,
        EndDate : params.endDate,
        Operator : params.operator,
        ProductType : params.productType,
        CompanyId: params.companyId,
        UserId: params.userId,
        RoleId: params.roleId,
    }
    let LowResponse;
    try{
        LowResponse = await axios.post(`/api/Counter/GetLowestCounterList`,data);
        if(LowResponse && LowResponse.status === 200){
            return LowResponse.data.records;
        }else{
            return LowResponse.status;
        }

    }catch(error){
        if(error.LowResponse.status === 401){
            return error.LowResponse.status;
        }
    }
}